<template>
  <OverlayLoader :visible="isLoading" />
  <div>
    <div class="card bg-white border-0 rounded-3 mb-4">
      <div class="card-body p-0">
        <div
          class="d-flex row justify-content-center align-items-center flex-wrap gap-2 p-4"
        >
          <h4>Engament</h4>
          <form class="position-relative table-src-form me-0" @submit.prevent>
            <div class="row">
              <div class="col-lg-3 col-sm-6">
                <div class="form-group mb-4">
                  <label class="label text-secondary strong"
                    >Tipo de reporte</label
                  >
                  <select
                    v-model="reportType"
                    class="form-select form-control h-45"
                    aria-label="Default select example"
                  >
                    <option value="player">Por Jugador</option>
                    <option value="team">Por Equipo</option>
                  </select>
                </div>
              </div>

              <!-- Filtros para reporte Por Jugador -->
              <template v-if="reportType === 'player'">
                <div class="col-lg-3 col-sm-6">
                  <div class="form-group mb-4">
                    <label class="label text-secondary strong">Empresa</label>
                    <select
                      v-model="filters.companyId"
                      class="form-select form-control h-45"
                      aria-label="Default select example"
                    >
                      <option :value="null">{{ LABELS.SELECT_ALL }}</option>
                      <option
                        :value="item.id"
                        v-for="(item, i) of itemsCompany"
                        :key="i"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </template>

              <!-- Filtros para reporte Por Equipo -->
              <template v-else>
                <div class="col-lg-3 col-sm-6">
                  <div class="form-group mb-4">
                    <label class="label text-secondary strong">Torneo</label>
                    <select
                      v-model="filters.tournamentId"
                      class="form-select form-control h-45"
                      aria-label="Default select example"
                    >
                      <option :value="null">{{ LABELS.SELECT_ALL }}</option>
                      <option
                        :value="item.id"
                        v-for="(item, i) of itemsTournament"
                        :key="i"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-lg-3 col-sm-6">
                  <div class="form-group mb-4">
                    <label class="label text-secondary strong">Empresa</label>
                    <select
                      v-model="filters.companyId"
                      class="form-select form-control h-45"
                      aria-label="Default select example"
                    >
                      <option :value="null">{{ LABELS.SELECT_ALL }}</option>
                      <option
                        :value="item.id"
                        v-for="(item, i) of itemsCompany"
                        :key="i"
                      >
                        {{ item.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </template>
              <div class="col-lg-3 col-sm-6 text-end mt-4">
                <div class="d-inline-flex flex-wrap gap-3 justify-content-end">
                  <button
                    type="button"
                    @click.prevent="getReport()"
                    class="btn btn-outline-primary py-1 px-3 fw-medium fs-14 hover-bg"
                  >
                    Generar reporte
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    <div class="card bg-white border-0 rounded-3 mb-4">
      <div class="card-body p-0">
        <div
          class="d-flex row justify-content-center align-items-center flex-wrap gap-2 p-4"
        >
          <h4>Drop/Cancelación de jugada</h4>
          <form class="position-relative table-src-form me-0" @submit.prevent>
            <div class="row">
              <div class="col-lg-3 col-sm-6">
                <div class="form-group mb-4">
                  <label class="label text-secondary strong">Torneo</label>
                  <select
                    v-model="filtersDrop.tournamentId"
                    class="form-select form-control h-45"
                    aria-label="Default select example"
                    @change="getMatchesByTournament()"
                  >
                    <option :value="null">{{ LABELS.SELECT }}</option>
                    <option
                      :value="item.id"
                      v-for="(item, i) of itemsTournament"
                      :key="i"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6">
                <div class="form-group mb-4">
                  <label class="label text-secondary strong">Partido</label>
                  <select
                    v-model="filtersDrop.matchId"
                    class="form-select form-control h-55"
                    aria-label="Default select example"
                    @change="getPlayByTournamentMatch()"
                  >
                    <option :value="0">{{ LABELS.SELECT_ALL }}</option>
                    <option
                      :value="item.id"
                      v-for="(item, i) of itemsMatch"
                      :key="i"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6">
                <div class="form-group mb-4">
                  <label class="label text-secondary strong">Jugada</label>
                  <select
                    v-model="filtersDrop.playId"
                    class="form-select form-control h-55"
                    aria-label="Default select example"
                  >
                    <option :value="0">{{ LABELS.SELECT_ALL }}</option>
                    <option
                      :value="item.id"
                      v-for="(item, i) of itemsPlay"
                      :key="i"
                    >
                      {{ item.name }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-lg-3 col-sm-6 text-end mt-4">
                <div class="d-inline-flex flex-wrap gap-3 justify-content-end">
                  <button
                    type="button"
                    @click.prevent="getReportDrop()"
                    class="btn btn-outline-primary py-1 px-3 fw-medium fs-14 hover-bg"
                  >
                    Generar reporte
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import OverlayLoader from "@/components/Others/OverlayLoader.vue";
import api from "@/services/api";
import { STATUS, LABELS, COMPANY_TYPES } from "@/utils/constants";

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Reports_TournamentStatistics",
  components: {
    OverlayLoader,
  },
  setup() {
    const isLoading = ref(false);
    const reportType = ref<"player" | "team">("player");
    const itemsCompany = ref<any[]>([]);
    const itemsTournament = ref<any[]>([]);
    const itemsMatch = ref<any[]>([]);
    const itemsPlay = ref<any[]>([]);

    const filters = ref({
      companyId: null as number | null,
      tournamentId: null as number | null,
    });
    const filtersDrop = ref({
      playId: 0 as number | null,
      tournamentId: null as number | null,
      matchId: 0 as number | null,
    });
    onMounted(async () => {
      await Promise.all([getCompanies(), getTournaments()]);
    });

    const getCompanies = async () => {
      try {
        const response = await api.get(
          `/common/companies?type=${COMPANY_TYPES.PARTICIPANTE}`
        );
        itemsCompany.value = response.data;
      } catch (error) {
        console.error(error);
      }
    };

    const getTournaments = async () => {
      try {
        const params = `pageNumber=1&pageSize=99999&isActive=true`;
        const response = await api.get(`/tournament?${params}`);
        itemsTournament.value = response.data.list;
      } catch (error) {
        console.error(error);
      }
    };

    const getReport = async () => {
      try {
        isLoading.value = true;
        const paramsObj: Record<string, any> = { type: reportType.value };
        if (filters.value.companyId)
          paramsObj.companyId = filters.value.companyId;
        if (reportType.value === "team" && filters.value.tournamentId)
          paramsObj.tournamentId = filters.value.tournamentId;

        const params = new URLSearchParams(paramsObj as any).toString();

        const response: any = await api.get(
          `/reports/tournament_statistics?${params}`,
          { responseType: "blob" }
        );

        const contentDisposition =
          response.headers["content-disposition"] ||
          response.headers["Content-Disposition"];

        let fileName = "report.xlsx";

        if (contentDisposition) {
          // Try filename* (UTF-8 encoded)
          let utf8FilenameRegex = /filename\*\s*=\s*UTF-8''([^;\n]*)/i;
          let matches = utf8FilenameRegex.exec(contentDisposition);

          if (matches && matches[1]) {
            fileName = decodeURIComponent(matches[1]); // decode UTF-8 filename
          } else {
            // Fallback to plain filename
            let simpleFilenameRegex = /filename\s*=\s*([^;\n]*)/i;
            matches = simpleFilenameRegex.exec(contentDisposition);
            if (matches && matches[1]) {
              fileName = matches[1].replace(/['"]/g, "");
            }
          }
        }

        console.log("Filename:", fileName);

        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
      } catch (error) {
        console.error(error);
      } finally {
        isLoading.value = false;
      }
    };
    const getMatchesByTournament = async () => {
      try {
        itemsMatch.value = [];
        itemsPlay.value = [];
        filtersDrop.value.matchId = 0;
        filtersDrop.value.playId = 0;

        var params = `pageNumber=1&pageSize=99999&isActive=true`;
        params = params + `&tournamentId=${filtersDrop.value.tournamentId}`;

        const response = await api.get(`/match?${params}`);

        itemsMatch.value = response.data.list;
      } catch (error) {
        console.error(error);
      }
    };
    const getPlayByTournamentMatch = async () => {
      itemsPlay.value = [];
      filtersDrop.value.playId = 0;
      try {
        var params = `idTournament=${filtersDrop.value.tournamentId}&idMatch=${filtersDrop.value.matchId}`;
        const response = await api.get(
          `/common/play-by-tournament-match?${params}`
        );
        itemsPlay.value = response.data;
      } catch (ex) {
        console.error(ex);
      }
    };
    const getReportDrop = async () => {
         if (!filtersDrop.value.tournamentId) {
        alert('Por favor seleccione un torneo');
        return;
      }
      try {
        isLoading.value = true;
        const paramsObj: Record<string, any> = {};
        paramsObj.tournamentId = filtersDrop.value.tournamentId;
        paramsObj.matchId = filtersDrop.value.matchId;
        paramsObj.playId = filtersDrop.value.playId;

        const params = new URLSearchParams(paramsObj as any).toString();

        const response: any = await api.get(
          `/reports/tournament_statistics_drop?${params}`,
          { responseType: "blob" }
        );

        const contentDisposition =
          response.headers["content-disposition"] ||
          response.headers["Content-Disposition"];

        let fileName = "reportDrop.xlsx";

        if (contentDisposition) {
          // Try filename* (UTF-8 encoded)
          let utf8FilenameRegex = /filename\*\s*=\s*UTF-8''([^;\n]*)/i;
          let matches = utf8FilenameRegex.exec(contentDisposition);

          if (matches && matches[1]) {
            fileName = decodeURIComponent(matches[1]); // decode UTF-8 filename
          } else {
            // Fallback to plain filename
            let simpleFilenameRegex = /filename\s*=\s*([^;\n]*)/i;
            matches = simpleFilenameRegex.exec(contentDisposition);
            if (matches && matches[1]) {
              fileName = matches[1].replace(/['"]/g, "");
            }
          }
        }

        console.log("Filename:", fileName);

        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
      } catch (error) {
        console.error(error);
      } finally {
        isLoading.value = false;
      }
    };
    return {
      itemsCompany,
      itemsTournament,
      STATUS,
      LABELS,
      OverlayLoader,
      filters,
      filtersDrop,
      reportType,
      isLoading,
      getReport,
      getReportDrop,
      getMatchesByTournament,
      getPlayByTournamentMatch,
      itemsMatch,
      itemsPlay,
    };
  },
});
</script>
